/**
 * Copyright (c) Qwoach LLC 2026. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */

export const GenogramAnalyticsEventName = Object.freeze({
	TOOL_OPENED: "Genogram tool opened",
	SESSION_STARTED: "Genogram session started",
	REVISITED: "Genogram revisited",
	MEANINGFUL_EDITING_DETECTED: "Genogram meaningful editing detected",
	SAVED: "Genogram saved",
	EXPORTED: "Genogram exported",
	CONTEXT_PROMPT_COMPLETED: "Genogram context prompt completed",
})

export const GenogramAnalyticsSurveyName = Object.freeze({
	EXPANSION_SIGNALS: "Genogram expansion signals",
})
